import { Link } from 'react-router-dom';

import Button from '@/components/ui/buttons/Button';

import CSSModule from './TokenVerificationError.module.scss';

const TokenVerificationError: React.FC = () => (
  <div className={CSSModule.TokenVerificationError}>
    <div className={CSSModule.TokenVerificationError__Inner}>
      <h3 className={CSSModule.TokenVerificationError__Title}>
        URLの有効期限が過ぎています
      </h3>

      <div className={CSSModule.TokenVerificationError__Description}>
        認証ができませんでした。
        <br />
        再度設定の手続きを行ってください。
      </div>

      <Button
        tag={Link}
        to="/forgot"
        color="outline"
        className={CSSModule.TokenVerificationError__BackToForgot}
      >
        パスワードの再設定へ
      </Button>
    </div>
  </div>
);

export default TokenVerificationError;
